import React, { useEffect, useState } from "react";
import { createPortal } from 'react-dom';
import { Trans, useTranslation } from "react-i18next";
import { useUserContext } from "hooks";
import { AppsClient, ApiClient } from "services";
import { useHistory } from "react-router-dom";
import Login from "./Auth/Login";
import OrganisationsSelection from "./Auth/OrganisationsSelection";
import Register from "./Auth/Register";
import { NotificationManager } from "react-notifications";


function paramsToObject(entries) {
  const result = {}
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
}

export const CallBackHandler = ({ match, }) => {

  const { app } = match.params;
  const apps_client = AppsClient()
  const client = ApiClient()
  let history = useHistory();
  const { user } = useUserContext();
  const t = useTranslation();

  const [domReady, setDomReady] = React.useState(false)
  const [register, setRegister] = useState(false)
  const [onBoarding, setOnBoarding] = useState(false)

  const [tokeInfo, setTokenInfo] = useState(JSON.parse(localStorage.getItem(`${app}__token_info`)))

  const get_query_params = () => {
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    const params_dict = paramsToObject(params)
    return params_dict
  }

  const onConnect = (connected_organisation_id) => {
    client.post(`apps/${connected_organisation_id}/${app}/connection/callback`, tokeInfo).then((resp) => {
      localStorage.removeItem(`${app}__token_info`);
      history.push("/applications");
    }).catch((err) => {
      NotificationManager.error(
        t("Couldn't Connect", {})
      )
    })
  }


  const loadTokenInfo = () => {
    const params_dict = get_query_params()
    client.post(`apps/0/${app}/connection/get_token`, params_dict).get('data').then((resp) => {
      if (resp.error) return
      localStorage.setItem(`${app}__token_info`, JSON.stringify(resp));
      setTokenInfo(resp)
    })
  }

  useEffect(async () => {
    if (!tokeInfo) {
      loadTokenInfo()
    }
    setDomReady(true)
  }, [])

  return domReady ? (
    <>
      {(onBoarding) ? createPortal(
        <div className="content">
          <h4><Trans>Connecting...</Trans></h4>
          <p className=""><Trans>Please wait while we redirect you.</Trans></p>
        </div>,
        document.querySelector('#loader-holder')
      ) : createPortal(
        <div className="content full-cover">
          <div className="redirect-wrapper border py-4 px-3 rounded">
            <div className="row">
              <div className="col-4">
                <img src="/images/logo.svg" alt="Logo" style={{ width: "100px" }} className="rounded border rounded-circle p-1"></img>
              </div>
              <div className="col-4 d-flex align-items-center justify-content-center display-7" style={{ opacity: "0.5" }}>
                <i className="fa fa-exchange-alt" aria-hidden="true"></i>
              </div>
              <div className="col-4">
                <img src="/images/applications/salla application.png" alt="Logo" style={{ width: "100px" }} className="border p-1"></img>
              </div>
            </div>
            <h3 className="my-3"><Trans>Authorize Hesaab to access</Trans> <span style={{ textTransform: 'capitalize' }} className="text-success"><Trans>{app}</Trans></span></h3>
            {user ?
              <div className="row m-auto">
                <div className="col px-0">
                  <OrganisationsSelection setOnBoarding={setOnBoarding} onConnect={onConnect} />
                </div>
              </div>
              :
              <div className="auth">
                {register ?
                  <Register app={app} setRegister={setRegister} tokeInfo={tokeInfo} client={client} />
                  :
                  <Login app={app} setRegister={setRegister} tokeInfo={tokeInfo} />
                }
              </div>
            }
          </div>
        </div>,
        document.querySelector('#loader-holder')
      )
      }
    </>
  ) :
    null
}


export default CallBackHandler;
